import {
  combineReducers,
  configureStore,
  EnhancedStore
} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { Store } from 'redux';

import deviceTelemetrySlice from '../features/telemetry/device-telemetry-slice';
import devicesSlice from '../features/devices/devices-slice';
import userSlice from '../features/user/user-slice';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
const reducer = combineReducers({
  DevicesReducer: devicesSlice.reducer,
  UserReducer: userSlice.reducer,
  DeviceTelemetryReducer: deviceTelemetrySlice.reducer
});

const store: EnhancedStore & Store = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
